import {axiosGet} from "../../../Helpers/AxiosHelper";

const state = {
    eveList: []
};

const getters = {
    getEve: state => state.eveList
};

const actions = {
    getEve({commit}) {
        axiosGet(`crm/eves?all`).then(({data}) => {
            commit('EVE_INFO', data)
        }).catch((error) => console.log(error));
    },
};

const mutations = {
    EVE_INFO(state, data) {
        state.eveList = data;
    }
};


export default {
    state,
    getters,
    actions,
    mutations
}
